import React, {memo, useCallback, useEffect, useRef} from "react";
import {Control, Controller} from "react-hook-form";
import {Div, Text} from "../../Kit";
import {colors} from "../../../StyleSheet";

export type VerificationInputProps = {
    control: Control<any>;
    name: string;
};

const OTP_LENGTH = 5;

export const VerificationInput: React.FC<VerificationInputProps> = memo(
({control, name}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleFocus = useCallback(() => {
        inputRef.current?.focus();
    }, []);

    return (
        <Controller
            control={control}
            name={name}
            defaultValue=""
            render={({field}) => {
                const otp = field.value || "";

                return (
                    <div className="w-full">
                        <div
                            className="relative flex w-full justify-between gap-[6px] ltr cursor-text"
                            onClick={handleFocus}
                        >
                            {Array.from({length: OTP_LENGTH}, (_, index) => {
                                const isActive =
                                    otp.length < OTP_LENGTH &&
                                    index === otp.length;

                                return (
                                    <Div
                                        key={index}
                                        border={`1px solid ${
                                            isActive
                                                ? colors.primary
                                                : "#666666"
                                        }`}
                                        className="w-[50px] h-[50px] flex justify-center items-center rounded-[5px] transition-colors"
                                    >
                                        <Text
                                            elementType="span"
                                            translatable={false}
                                        >
                                            {otp[index] || ""}
                                        </Text>
                                    </Div>
                                );
                            })}

                            <input
                                ref={inputRef}
                                value={otp}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,5}$/.test(value)) {
                                        field.onChange(value);
                                    }
                                }}
                                type="tel"
                                inputMode="numeric"
                                autoComplete="one-time-code"
                                maxLength={OTP_LENGTH}
                                className="absolute inset-0 w-full h-full opacity-0 cursor-text"
                                aria-label="Verification code"
                            />
                        </div>
                    </div>
                );
            }}
        />
    );
}
);

VerificationInput.displayName = "VerificationInput";